<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="copyright left">V2.0.</div>
      <div class="copyright">&copy; {{ year }}, SISCOP.</div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style scoped>
.left {
  float: left !important;
}
.footer {
  background-color: #2196f3 !important;
}
</style>